import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import type { Session } from '../lib/supabase';
import styles from './LoginPage.module.css';

interface Props {
  isAdmin?: boolean;
  session?: Session | null;
}

export default function LoginPage({ isAdmin, session }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { data, error: authError } = await supabase.auth.signInWithPassword({ email, password });

    if (authError) {
      setError(authError.message);
      setLoading(false);
      return;
    }

    if (data.user) {
      // Check admin
      const { data: adminRow } = await supabase
        .from('users')
        .select('id')
        .eq('id', data.user.id)
        .eq('is_admin', true)
        .maybeSingle();

      if (!adminRow) {
        await supabase.auth.signOut();
        setError('관리자 권한이 없습니다.');
        setLoading(false);
        return;
      }

      supabase.from('login_logs').insert({ user_id: data.user.id, device: 'web' }).then(() => {});
    }

    setLoading(false);
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Logo */}
        <div className={styles.logo}>
          <span className={styles.logoStar}>✦</span>
          <div>
            <div className={styles.logoTitle}>Gang-Z</div>
            <div className={styles.logoSub}>ADMIN CONSOLE</div>
          </div>
        </div>

        <form onSubmit={handleLogin} className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label}>이메일</label>
            <input
              className="input"
              type="email"
              placeholder="admin@envoca.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>비밀번호</label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className={styles.error}>{error}</div>}
          {session && !isAdmin && !error && (
            <div className={styles.error}>관리자 권한이 없습니다.</div>
          )}
          <button className="btn btn-primary" style={{ width: '100%', padding: '14px' }} disabled={loading}>
            {loading ? '확인 중...' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
}
